<template>
  <div class="km__stage__3dmodel--wrapper konfi-preloading">
    <div id="preload-layer"><img src="/src/assets/preloader_shirt_final.gif" alt="loading" /></div>
    <div id="3DViewer" class="km__stage__3dmodel--canvas"></div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.km__stage__3dmodel--wrapper {
  width: 100%;
}


  .fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index:99999999999999999999999999999;
  }


.konfi-preloading {

  .km__stage__3dmodel--canvas {
    opacity: 0;
  }

  #preload-layer {
    opacity: 1;
    z-index: 99999;
  }
}

#preload-layer {
  -webkit-transition: all .4s ease-in-out;
  -moz-transition: all .4s ease-in-out;
  -ms-transition: all .4s ease-in-out;
  -o-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 670px;
  z-index: -1;
  opacity: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 90px;

  @media screen and (max-width: 980px) {
    height: 390px;
    padding-bottom: 0;
  }

  @media screen and (max-width: 600px) {
    img {
      max-width: 120px;
    }
  }
}
</style>
